import { render } from "./Form25Edit.vue?vue&type=template&id=7ff2a76f"
import script from "./Form25Edit.vue?vue&type=script&lang=js"
export * from "./Form25Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__